import React from "react";
import Products from "./Products";
import { Box } from "@mui/material";

const Home = () => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "auto",
          gap: "20px",
          height: "1000px",

          alignItems: "center",

          padding: "20px 20px",
        }}
      >
        <Products />
      </Box>
    </>
  );
};

export default Home;
